import React from 'react';

import { Paper } from "@mui/material";
import { styled } from '@mui/material/styles';

export const Card = styled((props) => <Paper elevation={0} {...props} />)`
	border-radius: 12px;
`